import {
  get,
  remove,
  isNull,
  isUndefined,
  find,
  forEach,
  isEmpty,
} from "lodash";
import themeDefault from "../utils/themeDefault";
let Property = (function () {
  const prefix = "okkami_webstore_";

  let setProductURL = function (productUrl) {
    localStorage.setItem(prefix + "productUrl", productUrl);
  };

  let setProductOffset = function (productOffset) {
    localStorage.setItem(prefix + "productOffset", productOffset);
  };

  const setWebStoreType = (param) => {
    localStorage.setItem(prefix + "webStoreType", JSON.stringify(param));
  };

  const getWebStoreType = () => {
    return JSON.parse(localStorage.getItem(prefix + "webStoreType"));
  };

  let setData = function (propertyData) {
    clearPayment();
    if (propertyData.store) {
      setOrderInfo(propertyData.store.uid, "Store");
      localStorage.setItem(
        prefix + "interfaceType",
        get(propertyData, "store.kind", "")
      );
      localStorage.setItem(
        prefix + "store_unpaired_available",
        JSON.stringify(get(propertyData, "store.unpaired_available", false))
      );
      const paymentMethod = {
        enable_bill_to_room: get(
          propertyData,
          "store.enable_bill_to_room",
          false
        ),
        enable_pay_by_cash: get(
          propertyData,
          "store.enable_pay_by_cash",
          false
        ),
        bill_to_room: get(propertyData, "store.bill_to_room", ""),
        pay_by_cash: get(propertyData, "store.pay_by_cash", ""),
      };
      localStorage.setItem(
        prefix + "paymentMethod",
        JSON.stringify(paymentMethod)
      );
      // clearCartItem();
    } else if (propertyData.category) {
      setOrderInfo(propertyData.category.uid, "Category");
      localStorage.setItem(
        prefix + "interfaceType",
        get(propertyData, "store_interface_type", "")
      );
      localStorage.removeItem(prefix + "store_unpaired_available");
      const paymentMethod = {
        enable_bill_to_room: get(
          propertyData,
          "store_enable_bill_to_room",
          false
        ),
        enable_pay_by_cash: get(
          propertyData,
          "store_enable_pay_by_cash",
          false
        ),
        bill_to_room: get(propertyData, "store_bill_to_room", ""),
        pay_by_cash: get(propertyData, "store_pay_by_cash", ""),
      };
      localStorage.setItem(
        prefix + "paymentMethod",
        JSON.stringify(paymentMethod)
      );
      // clearCartItem();
    }
    localStorage.setItem(prefix + "propertyData", JSON.stringify(propertyData));
  };

  let getProductURL = function () {
    return localStorage.getItem(prefix + "productUrl");
  };

  let getProductOffset = function () {
    return localStorage.getItem(prefix + "productOffset");
  };

  let getData = function (propertyUid = "") {
    const response = JSON.parse(localStorage.getItem(prefix + "propertyData"));
    if (isEmpty(propertyUid) || get(response, "uid") === propertyUid)
      return response || null;
    return null;
  };

  const getLanguages = () => {
    const data = getData();
    return get(data, "supported_languages", []);
  };

  const getStore = () => {
    const data = getData();
    return get(data, "store", {});
  };

  let getCategory = function (id) {
    let data = getData();
    if (
      isEmpty(data) ||
      isEmpty(id) ||
      (isEmpty(get(data, "store.categories")) && isEmpty(get(data, "category")))
    ) {
      return null;
    }

    if (data.store) {
      return data.store.categories.find((category) => category.uid === id);
    } else if (data.category?.uid === id) {
      return data.category;
    }
  };

  const getCatalogStatus = () => {
    let data = getData();
    const catalogStatus = get(data, "catalog_status", false);
    return catalogStatus;
  };

  let getProduct = function (id) {
    let data = getData();
    if (isEmpty(data)) {
      return null;
    }
    let unpaired_available = false;

    let product = null;
    if (data.store) {
      for (let category of data.store.categories) {
        for (let section of category.sections) {
          product = section.products.find((product) => product.uid === id);
          if (!!product) {
            if (!unpaired_available) {
              unpaired_available =
                data.store.unpaired_available ||
                category.unpaired_available ||
                product.unpaired_available;
            }
            localStorage.setItem(
              prefix + "productAvailableForUnpair",
              unpaired_available
            );
            return product;
          }
        }
      }
    } else if (data.category) {
      for (let section of data.category.sections) {
        product = section.products.find((product) => product.uid === id);
        if (!!product) {
          if (!unpaired_available) {
            unpaired_available =
              data.category.unpaired_available || product.unpaired_available;
          }
          localStorage.setItem(
            prefix + "productAvailableForUnpair",
            unpaired_available
          );
          return product;
        }
      }
    }

    return null;
  };

  let setUid = function (propertyUid) {
    localStorage.setItem(prefix + "propertyUid", propertyUid);
  };

  let getUid = function () {
    const propertyUid = localStorage.getItem(prefix + "propertyUid");
    if (propertyUid) {
      return propertyUid;
    }

    let data = getData();
    return data ? data.uid : null;
  };

  let setAccessToken = function (accessToken) {
    if (isNull(accessToken)) {
      localStorage.removeItem(prefix + "propertyAccessToken");
    } else {
      localStorage.setItem(prefix + "propertyAccessToken", accessToken);
    }
  };

  let getAccessToken = function () {
    return localStorage.getItem(prefix + "propertyAccessToken");
  };

  let setEmail = function (propertyUid, email) {
    localStorage.setItem(prefix + `email_${propertyUid}`, email);
  };

  let getEmail = function (propertyUid) {
    return localStorage.getItem(prefix + `email_${propertyUid}`);
  };

  const setPairGuest = function (pairGuest) {
    let oldKey = localStorage.getItem(prefix + "propertyPairGuest");
    if (oldKey !== pairGuest) {
      localStorage.removeItem(prefix + "cartItem");
    }

    if (pairGuest === null) {
      localStorage.removeItem(prefix + "propertyPairGuest");
    } else {
      localStorage.setItem(prefix + "propertyPairGuest", pairGuest);
    }
  };

  let getPairGuest = function () {
    return JSON.parse(localStorage.getItem(prefix + "propertyPairGuest"));
  };

  const setSignIn = function (signIn) {
    let oldKey = localStorage.getItem(prefix + "propertySignIn");
    if (oldKey !== signIn) {
      localStorage.removeItem(prefix + "cartItem");
    }

    if (signIn === null) {
      localStorage.removeItem(prefix + "propertySignIn");
    } else {
      localStorage.setItem(prefix + "propertySignIn", signIn);
    }
  };

  const getSignIn = function () {
    return JSON.parse(localStorage.getItem(prefix + "propertySignIn"));
  };

  let setPlatform = function (platform) {
    if (platform === null) {
      localStorage.removeItem(prefix + "propertyPlatform");
    } else {
      localStorage.setItem(prefix + "propertyPlatform", platform);
    }
  };

  let getPlatform = function () {
    return localStorage.getItem(prefix + "propertyPlatform");
  };

  const setMobileProperty = function (mobileProperty) {
    if (mobileProperty === null) {
      localStorage.removeItem(prefix + "mobileProperty");
    } else {
      localStorage.setItem(prefix + "mobileProperty", mobileProperty);
    }
  };

  let getMobileProperty = function () {
    return localStorage.getItem(prefix + "mobileProperty");
  };

  let setDeviceType = function (deviceType) {
    if (deviceType === null) {
      localStorage.removeItem(prefix + "propertyDeviceType");
    } else {
      localStorage.setItem(prefix + "propertyDeviceType", deviceType);
    }
  };

  let getDeviceType = function () {
    return localStorage.getItem(prefix + "propertyDeviceType");
  };

  let setTableNo = function (tableNo) {
    if (tableNo === null) {
      localStorage.removeItem(prefix + "storeTabeleNo");
    } else {
      localStorage.setItem(prefix + "storeTabeleNo", tableNo);
    }
  };

  let getTableNo = function () {
    return localStorage.getItem(prefix + "storeTabeleNo");
  };

  let setExpireKey = function (propertyExpireKey) {
    let oldKey = localStorage.getItem(prefix + "propertyExpireKey");
    if (oldKey !== propertyExpireKey) {
      localStorage.removeItem(prefix + "cartItem");
    }

    if (propertyExpireKey === null) {
      localStorage.removeItem(prefix + "propertyExpireKey");
    } else {
      localStorage.setItem(prefix + "propertyExpireKey", propertyExpireKey);
    }
  };

  let getExpireKey = function () {
    return localStorage.getItem(prefix + "propertyExpireKey");
  };

  let setOrderInfo = function (uid, type) {
    localStorage.setItem(
      prefix + "propertyOrderInfo",
      JSON.stringify({ uid: uid, type: type })
    );
  };

  let getOrderInfo = function () {
    return JSON.parse(localStorage.getItem(prefix + "propertyOrderInfo"));
  };

  let setCartItem = function (cartItem) {
    const data = getWebStoreType();
    if (isEmpty(data)) {
      return;
    }
    const puid = data.uid
    // localStorage.removeItem(prefix+"cartItem");
    const cartItems =
      JSON.parse(localStorage.getItem(prefix + puid + "cartItem")) || [];
    const uid = cartItem.uid;
    const itemQuantity = cartItem.item_quantity;
    const itemSelection = cartItem.item_selection;
    const maxQuantity = cartItem.max_quantity;
    let isNewItem = true;

    if (
      find(get(cartItem, "price_options", []), (cItem) => {
        return ["pick_product_price"].includes(cItem.type);
      })
    ) {
      isNewItem = true;
    } else {
      for (let item of cartItems) {
        if (item.uid === uid && item.item_selection === itemSelection) {
          isNewItem = false;
          if (
            isUndefined(maxQuantity) ||
            isNull(maxQuantity) ||
            maxQuantity > item.item_quantity
          ) {
            item.item_quantity = item.item_quantity + itemQuantity;
          }
          item.item_quantity_list = itemQuantity;
        }
      }
    }

    if ((cartItems && cartItems.length === 0) || isNewItem) {
      cartItems.push(cartItem);
    }
    localStorage.setItem(prefix + puid + "cartItem", JSON.stringify(cartItems));
  };

  let getCartItem = function () {
    const data = getWebStoreType();
    if (isEmpty(data)) {
      return [];
    }
    let cartItem = JSON.parse(localStorage.getItem(prefix + data.uid + "cartItem"));
    return cartItem || [];
  };

  let setCurrencyCode = function (currencyCode) {
    localStorage.setItem(prefix + "currencyCode", currencyCode);
  };

  const setOrderSuccess = (order) => {
    localStorage.setItem(prefix + "orderSuccess", JSON.stringify(order));
  };

  const getOrderSuccess = () => {
    return JSON.parse(localStorage.getItem(prefix + "orderSuccess"));
  };

  const clearOrderSuccess = () => {
    return localStorage.removeItem(prefix + "orderSuccess");
  };

  let getCurrencyCode = function () {
    return localStorage.getItem(prefix + "currencyCode") || "USD";
  };

  let editQuantityCartItems = function (hint, id, itemSelection) {
    const uid = getWebStoreType().uid;
    const cartItems = JSON.parse(localStorage.getItem(prefix + uid + "cartItem"));

    if (hint === "plus") {
      for (let item of cartItems) {
        if (item.uid === id && item.item_selection === itemSelection) {
          item.item_quantity = item.item_quantity + 1;
        }
      }
    } else {
      for (let [i, item] of cartItems.entries()) {
        if (item.uid === id && item.item_selection === itemSelection) {
          item.item_quantity = item.item_quantity - 1;
          if (item.item_quantity === 0) {
            cartItems.splice(i, 1);
          }
        }
      }
    }
    localStorage.setItem(prefix + uid + "cartItem", JSON.stringify(cartItems));
  };

  const removeCartItems = function (uid, itemSelection) {
    const puid = getWebStoreType().uid;
    const cartItems = JSON.parse(localStorage.getItem(prefix + puid + "cartItem"));
    remove(cartItems, { uid: uid, item_selection: itemSelection });
    localStorage.setItem(prefix + puid + "cartItem", JSON.stringify(cartItems));
  };

  let setPreviousTitle = function (previousTitle) {
    const titleItems =
      JSON.parse(localStorage.getItem(prefix + "previousTitle")) || [];
    titleItems.push({ title: previousTitle });
    localStorage.setItem(prefix + "previousTitle", JSON.stringify(titleItems));
  };

  let getPreviousTitle = function () {
    const titleItems =
      JSON.parse(localStorage.getItem(prefix + "previousTitle")) || [];
    let title = "";

    if (titleItems && titleItems.length > 0) {
      title = titleItems[titleItems.length - 1].title;
    }
    return title;
  };

  let popPreviousTitle = function () {
    const titleItems =
      JSON.parse(localStorage.getItem(prefix + "previousTitle")) || [];
    titleItems.pop();
    localStorage.setItem(prefix + "previousTitle", JSON.stringify(titleItems));
  };

  let clearPreviousTitle = function () {
    localStorage.removeItem(prefix + "previousTitle");
  };

  let setProductDetailData = function (item) {
    localStorage.setItem(prefix + "productDetailData", JSON.stringify(item));
  };

  let getProductDetailData = function () {
    return JSON.parse(localStorage.getItem(prefix + "productDetailData"));
  };

  let clearCartItem = function () {
    const data = getWebStoreType();
    if (isEmpty(data)) {
      return;
    }
    localStorage.removeItem(prefix + data.uid + "cartItem");
  };

  let getBasketOptions = function () {
    let data = getData();
    if (isEmpty(data)) {
      return [];
    }
    let options = null;
    if (data.store) {
      options = data.store.options;
    } else if (data.category) {
      options = data.category.options;
    }
    if (isNull(options)) {
      return [];
    } else {
      return options;
    }
  };

  let getDisplayOnlyCategory = function (id) {
    let data = getData();
    if (isEmpty(data)) {
      return false;
    }

    if (data.store) {
      return data.store.categories.find((category) => category.uid === id)
        .display_only;
    } else {
      return data.category.display_only;
    }
  };

  let getPairingUserStatus = function () {
    let data = getData();
    if (isEmpty(data) || !data.paired_user) {
      return false;
    }

    return data.paired_user;
  };

  const setPreset = (puid, item) => {
    let textColor =
      get(item, "app_home_text_call_to_action") ||
      get(item, "app_brand_text_call_to_action");
    if (isUndefined(textColor)) {
      textColor = "#ffffff";
    }
    let buttonStyleName = get(item, "buttonStyleName", "");
    if (isEmpty(buttonStyleName)) {
      const buttonStyle =
        get(item, "app_brand_call_to_acton_button_style") || "none";
      switch (buttonStyle) {
        case "none":
        case "round":
          buttonStyleName = "rounded-button";
          break;
        case "square":
          buttonStyleName = "square-button";
          break;
        case "small corner radius":
          buttonStyleName = "square-rounded-button";
          break;
        default:
          break;
      }
    }
    localStorage.setItem(
      prefix + "presetList",
      JSON.stringify({
        puid: puid,
        presets: {
          ...themeDefault,
          ...item,
          text_color: textColor,
          buttonStyleName,
        },
      })
    );
  };

  const getPreset = () => {
    const presets = JSON.parse(localStorage.getItem(prefix + "presetList"));
    if (isNull(presets)) {
      return { presets: { ...themeDefault } };
    }
    return get(presets, "presets", {});
  };

  const getPresetByUid = (puid) => {
    const presets = JSON.parse(localStorage.getItem(prefix + "presetList"));
    if (presets && presets.puid === puid) {
      return get(presets, "presets", {});
    }
    return {};
  };

  const setGuestService = (puid, item) => {
    localStorage.setItem(
      prefix + "guestService",
      JSON.stringify({ puid: puid, item: item })
    );
  };

  const getGuestService = (puid) => {
    const guestService = JSON.parse(
      localStorage.getItem(prefix + "guestService")
    );

    if (guestService && guestService.puid === puid) {
      return guestService.item || {};
    }
    return {};
  };

  const setConfiguration = (puid, item) => {
    localStorage.setItem(
      prefix + "configuration",
      JSON.stringify({ puid: puid, item: item })
    );
  };

  const getConfiguration = (puid) => {
    const configuration = JSON.parse(
      localStorage.getItem(prefix + "configuration")
    );
    if (configuration && configuration.puid === puid) {
      return configuration.item || {};
    }
    return {};
  };

  const getStoreUnpairedAvailable = () => {
    const storeUnpairedAvailable = JSON.parse(
      localStorage.getItem(prefix + "store_unpaired_available")
    );
    return storeUnpairedAvailable;
  };

  const getProductAvailableForUnpair = () => {
    const storeUnpairedAvailable = JSON.parse(
      localStorage.getItem(prefix + "productAvailableForUnpair")
    );
    return storeUnpairedAvailable;
  };

  const setArraySelectionOption = (arraySelectionOption) => {
    localStorage.setItem(
      prefix + "arraySelectionOption",
      JSON.stringify([...arraySelectionOption])
    );
  };

  const getArraySelectionOption = () => {
    const arraySelectionOption = JSON.parse(
      localStorage.getItem(prefix + "arraySelectionOption")
    );
    if (isNull(arraySelectionOption)) {
      return [];
    } else {
      return arraySelectionOption;
    }
  };

  const getTitleCapital = (title) => {
    const presets = JSON.parse(localStorage.getItem(prefix + "presetList"));
    let words = get(
      presets,
      "presets.app_webstore_reserved_all_capital_words",
      []
    );
    let result = title;
    if (typeof words === "string") words = [{ word: words }];
    if (isEmpty(words) || isNull(words)) return result;

    forEach(words, (word) => {
      let regex = new RegExp(`\\b${word.word.toLowerCase()}\\b`, "g");
      if (!isNull(word.word)) result = result.replace(regex, `${word.word}`);
    });
    return result;
  };

  const setRoomLastName = (info) => {
    localStorage.setItem(prefix + "roomLastName", JSON.stringify(info));
  };

  const getRoomLastName = () => {
    const roomLastName = JSON.parse(
      localStorage.getItem(prefix + "roomLastName")
    );
    return {
      lastName: get(roomLastName, "lastName", ""),
      roomNumber: get(roomLastName, "roomNumber", ""),
    };
  };

  const setPaymentId = (payment) => {
    const paymentInfo = {
      ...payment,
      id: payment.payment_id,
    };
    localStorage.setItem(prefix + "paymentInfo", JSON.stringify(paymentInfo));
  };

  const setNoteItemSelection = (notes) => {
    localStorage.setItem(prefix + "noteItemSelection", notes);
  };

  const getNoteItemSelection = () => {
    return localStorage.getItem(prefix + "noteItemSelection");
  };

  const getPayment = () => {
    return JSON.parse(localStorage.getItem(prefix + "paymentInfo"));
  };

  const clearPayment = () => {
    localStorage.removeItem(prefix + "noteItemSelection");
    localStorage.removeItem(prefix + "paymentInfo");
    localStorage.removeItem(prefix + "roomLastName");
    localStorage.removeItem(prefix + "paymentSelected");
    localStorage.removeItem(prefix + "arraySelectionOption");
  };

  const getStoreInterfaceType = () => {
    return localStorage.getItem(prefix + "interfaceType");
  };

  const setCategoryTopIndex = (index) => {
    localStorage.setItem(prefix + "webStoreCategoryTopIndex", index);
  };

  const getCategoryTopIndex = () => {
    return localStorage.getItem(prefix + "webStoreCategoryTopIndex");
  };

  const getPaymentMethod = () => {
    return JSON.parse(localStorage.getItem(prefix + "paymentMethod"));
  };

  const setPaymentSelected = (value) => {
    localStorage.setItem(prefix + "paymentSelected", value);
  };

  const getPaymentSelected = () => {
    return localStorage.getItem(prefix + "paymentSelected");
  };

  const setPublishableKey = (propertyUid, value) => {
    let stripeKeys = {};
    stripeKeys[propertyUid] = value;
    localStorage.setItem(prefix + "publishableKey", JSON.stringify(stripeKeys));
  };

  const getPublishableKey = (propertyUid) => {
    const stripeKeys = localStorage.getItem(prefix + "publishableKey");
    if (stripeKeys) return JSON.parse(stripeKeys)[propertyUid];
    return false;
  };

  const setWebStoreHomePage = (url) => {
    localStorage.setItem(prefix + "webstoreHomePage", url);
  };

  const getWebStoreHomePage = () => {
    return localStorage.getItem(prefix + "webstoreHomePage");
  };

  const setHistoryStack = (urls) => {
    localStorage.setItem(prefix + "histories", JSON.stringify(urls));
  };

  const getHistoryStack = () => {
    return JSON.parse(localStorage.getItem(prefix + "histories")) || [];
  };

  const setInputEmail = (email) => {
    localStorage.setItem(prefix + "email_input", email);
  };

  const getInputEmail = () => {
    return localStorage.getItem(prefix + "email_input")
  };

  const setEmailInvalid = (email) => {
    localStorage.setItem(prefix + "email_invalid", email);
  };

  const getEmailInvalid = () => {
    return JSON.parse(localStorage.getItem(prefix + "email_invalid"));
  };

  const setPaymentTransaction = (paymentTransaction) => {
    localStorage.setItem(
      prefix + "payment_transaction",
      JSON.stringify(paymentTransaction)
    );
  };

  const getPaymentTransaction = () => {
    return JSON.parse(localStorage.getItem(prefix + "payment_transaction"));
  };

  const setPollingAccessToken = (pollingAccessToken) => {
    localStorage.setItem(prefix + "polling_access_token", pollingAccessToken);
  };

  const getPollingAccessToken = () => {
    return localStorage.getItem(prefix + "polling_access_token");
  };

  const setStoredPaymentData = (storedPaymentData) => {
    localStorage.setItem(prefix + "storedPaymentData", storedPaymentData);
  };

  const getStoredPaymentData = () => {
    return localStorage.getItem(prefix + "storedPaymentData");
  };

  const removeStoredPaymentData = () => {
    return localStorage.removeItem(prefix + "storedPaymentData");
  };

  const setReservation = (reservation) => {
    localStorage.setItem(prefix + "reservation", JSON.stringify(reservation));
  };

  const getReservation = () => {
    return JSON.parse(localStorage.getItem(prefix + "reservation"));
  };

  const setHotelkeyPaymentLink = (hotelkeyPaymentLink) => {
    localStorage.setItem(
      prefix + "hotelkeyPaymentLink",
      JSON.stringify(hotelkeyPaymentLink)
    );
  };

  const getHotelkeyPaymentLink = () => {
    return JSON.parse(localStorage.getItem(prefix + "hotelkeyPaymentLink"));
  };

  const setDefaultLanguage = (param) => {
    localStorage.setItem(prefix + "defaultLanguage", JSON.stringify(param));
  };

  const getDefaultLanguage = () => {
    return JSON.parse(localStorage.getItem(prefix + "defaultLanguage"));
  };

  return {
    getProductURL: getProductURL,
    setProductURL: setProductURL,
    getProductOffset: getProductOffset,
    setProductOffset: setProductOffset,
    getData: getData,
    setData: setData,
    getUid: getUid,
    setUid: setUid,
    getExpireKey: getExpireKey,
    setExpireKey: setExpireKey,
    getAccessToken: getAccessToken,
    setAccessToken: setAccessToken,
    getDeviceType: getDeviceType,
    setDeviceType: setDeviceType,
    getTableNo: getTableNo,
    setTableNo: setTableNo,
    getPlatform: getPlatform,
    setPlatform: setPlatform,
    getCategory: getCategory,
    getProduct: getProduct,
    getCatalogStatus: getCatalogStatus,
    getOrderInfo: getOrderInfo,
    setCartItem: setCartItem,
    getCartItem: getCartItem,
    setCurrencyCode: setCurrencyCode,
    getCurrencyCode: getCurrencyCode,
    editQuantityCartItems: editQuantityCartItems,
    removeCartItems: removeCartItems,
    setPreviousTitle: setPreviousTitle,
    getPreviousTitle: getPreviousTitle,
    popPreviousTitle: popPreviousTitle,
    clearPreviousTitle: clearPreviousTitle,
    setProductDetailData: setProductDetailData,
    getProductDetailData: getProductDetailData,
    clearCartItem: clearCartItem,
    getBasketOptions: getBasketOptions,
    getDisplayOnlyCategory: getDisplayOnlyCategory,
    getPairingUserStatus: getPairingUserStatus,
    setOrderSuccess: setOrderSuccess,
    getOrderSuccess: getOrderSuccess,
    clearOrderSuccess: clearOrderSuccess,
    getLanguages: getLanguages,
    setWebStoreType: setWebStoreType,
    getWebStoreType: getWebStoreType,
    setPreset: setPreset,
    getPreset: getPreset,
    getPresetByUid: getPresetByUid,
    getStoreUnpairedAvailable: getStoreUnpairedAvailable,
    getMobileProperty: getMobileProperty,
    setMobileProperty: setMobileProperty,
    setPairGuest: setPairGuest,
    getPairGuest: getPairGuest,
    setSignIn: setSignIn,
    getSignIn: getSignIn,
    getProductAvailableForUnpair: getProductAvailableForUnpair,
    setArraySelectionOption: setArraySelectionOption,
    getArraySelectionOption: getArraySelectionOption,
    getTitleCapital: getTitleCapital,
    setNoteItemSelection: setNoteItemSelection,
    getNoteItemSelection: getNoteItemSelection,
    setRoomLastName: setRoomLastName,
    getRoomLastName: getRoomLastName,
    setPaymentId: setPaymentId,
    getPayment: getPayment,
    clearPayment: clearPayment,
    getStoreInterfaceType: getStoreInterfaceType,
    setCategoryTopIndex: setCategoryTopIndex,
    getCategoryTopIndex: getCategoryTopIndex,
    getPaymentMethod: getPaymentMethod,
    setPaymentSelected: setPaymentSelected,
    getPaymentSelected: getPaymentSelected,
    setPublishableKey: setPublishableKey,
    getPublishableKey: getPublishableKey,
    getStore: getStore,
    setGuestService: setGuestService,
    getGuestService: getGuestService,
    setConfiguration: setConfiguration,
    getConfiguration: getConfiguration,
    setWebStoreHomePage: setWebStoreHomePage,
    getWebStoreHomePage: getWebStoreHomePage,
    setHistoryStack: setHistoryStack,
    getHistoryStack: getHistoryStack,
    setEmail: setEmail,
    getEmail: getEmail,
    setInputEmail: setInputEmail,
    getInputEmail: getInputEmail,
    setEmailInvalid: setEmailInvalid,
    getEmailInvalid: getEmailInvalid,
    setPaymentTransaction: setPaymentTransaction,
    getPaymentTransaction: getPaymentTransaction,
    setPollingAccessToken: setPollingAccessToken,
    getPollingAccessToken: getPollingAccessToken,
    setStoredPaymentData: setStoredPaymentData,
    getStoredPaymentData: getStoredPaymentData,
    removeStoredPaymentData: removeStoredPaymentData,
    getReservation: getReservation,
    setReservation: setReservation,
    getHotelkeyPaymentLink: getHotelkeyPaymentLink,
    setHotelkeyPaymentLink: setHotelkeyPaymentLink,
    setDefaultLanguage: setDefaultLanguage,
    getDefaultLanguage: getDefaultLanguage,
  };
})();

export default Property;
